// extracted by mini-css-extract-plugin
export default {"tit_wrapper":"Title_tit_wrapper__fihht","tit_txt":"Title_tit_txt__CB8Z0","sub":"Title_sub__dK+gZ","tit":"Title_tit__kOdhf","desc":"Title_desc__0bJYq"};